module.exports = __webpack_public_path__ + "static/media/icon-email.2c325647.svg";